'use client'

import { Center, Flex, Icon, Text, CenterProps } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/hooks'
import { HiOutlineUpload } from 'react-icons/hi'
import useUrl from '@/hooks/useUrl'
import { SocialShareAreaModal } from './SocialShareAreaModal'

type ShareButtonType = CenterProps

export const ShareButton = ({ ...centerProps }: ShareButtonType) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { currentUrl } = useUrl()
  return (
    <>
      <Center {...centerProps}>
        <Flex alignItems="center" onClick={onOpen} color="gray.500" cursor="pointer">
          <Icon fontSize={['lg', 'lg', 'xl']} as={HiOutlineUpload} color="gray.500" mr={3} />
          <Text fontSize={['xs', 'xs', 'sm']}>共有する</Text>
        </Flex>
      </Center>
      <SocialShareAreaModal isOpen={isOpen} onClose={onClose} url={currentUrl} />
    </>
  )
}
